import {
  ADDTOCART,
  CARTDECREMENT,
  CARTINCREMENT,
  REMOVEFROMCART,
} from "./actionTypes";
import initialState from "./initialState";
const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDTOCART:
      let isItemExist = state.some((item) => action.payload.id === item.id);
      if (state.length === 0) {
        // if there is no item in the state then add the new item
        return [
          {
            id: action.payload.id,
            quantity: 1,
            stock: action.payload.stock,
          },
        ];
      } else if (isItemExist) {
        // if item exist in the product then increment its quantity
        return state.map((item) => {
          if (action.payload.id === item.id) {
            return {
              ...item,
              quantity:
                item.quantity < item.stock ? item.quantity + 1 : item.stock,
            };
          } else {
            return { ...item };
          }
        });
      } else {
        // if state isn't empty and item not exist there then add new item with old items
        return [
          ...state,
          { id: action.payload.id, quantity: 1, stock: action.payload.stock },
        ];
      }

    case REMOVEFROMCART:
      return state.filter((item) => action.payload.id !== item.id);

    case CARTINCREMENT:
      return state.map((item) => {
        if (action.payload.id === item.id) {
          return {
            ...item,
            quantity:
              item.quantity < item.stock ? item.quantity + 1 : item.stock,
          };
        } else {
          return {
            ...item,
          };
        }
      });

    case CARTDECREMENT:
      return state.map((item) => {
        if (action.payload.id === item.id) {
          return {
            ...item,
            quantity: item.quantity > 1 ? item.quantity - 1 : item.quantity,
          };
        } else {
          return {
            ...item,
          };
        }
      });

    default:
      return [...state];
  }
};

export default cartReducer;
